module.exports = __webpack_public_path__ + "static/media/logo.3958e2c6.svg";